import { Routes } from '@angular/router';
import { PageTitleEnum } from '@shared/enums';
import { userGuard } from '@core/guards';

export const orderRetestRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./order-retest-layout/order-retest-layout.component').then(mod => mod.OrderRetestLayoutComponent),
        children: [
            {
                path: '',
                redirectTo: 'sample-selection',
                pathMatch: 'full',
            },
            {
                path: 'sample-selection',
                loadComponent: () =>
                    import('./order-retest-step1/order-retest-step1.component').then(
                        mod => mod.OrderRetestStep1Component
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_RETEST_SAMPLE_SELECTION,
                data: { preload: true },
            },
            {
                path: 'sample-setup',
                loadComponent: () =>
                    import('./order-retest-step2/order-retest-step2.component').then(
                        mod => mod.OrderRetestStep2Component
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_RETEST_SAMPLE_SETUP,
                data: { preload: true },
            },
            {
                path: 'finalize',
                loadComponent: () =>
                    import('./order-retest-step3/order-retest-step3.component').then(
                        mod => mod.OrderRetestStep3Component
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_RETEST_FINALIZE,
            },
        ],
    },
    {
        path: 'confirmation',
        loadComponent: () =>
            import(
                '../../shared-features/order-setup/components/order-setup-confirmation/order-setup-confirmation.component'
            ).then(mod => mod.OrderSetupConfirmationComponent),
        canActivate: [userGuard],
        title: PageTitleEnum.ORDER_SETUP_CONFIRMATION_ORDER,
    },
];
